/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: Testimonial
 * Page name: Testimonial page
 * Page Description: This is the Testimonial page of the website of Ekathva Innovations.
*/
import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';

import { Card, Button, Col, Row, Container, Image } from 'react-bootstrap'
import React,{ useEffect } from 'react'
import Aos from 'aos'

import Aditya from 'assets/images/Testimonial/Aditya.jpg'
import Kiran from 'assets/images/Testimonial/Kiran.jpeg'
import Nakul from 'assets/images/Testimonial/Nakul.JPG'
import Niveditha from 'assets/images/Testimonial/Niveditha.jpg'
import Upendra from 'assets/images/Testimonial/Upendra.jpg'
import Vidyashankar from 'assets/images/Testimonial/Vidyashankar.JPEG'
import Gowrav from 'assets/images/Testimonial/gowrav.jpeg'
import Sachin from 'assets/images/Testimonial/Sachin.jpg'

import {ReactComponent as Comma} from "assets/images/Testimonial/Invertedcomma.svg"

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function Testi() {

  useEffect( () => {
    Aos.init({ })
  }, [])


  return (
    <div>
    <div>
    <Carousel
    autoPlay={true}
    responsive={responsive}
    infinite={true}
    autoPlaySpeed={2500}
    >

      <Row>
        <Col>
         <div className='homepagetestimonial_carouselspacing'>
         <div className='homepagetestimonial_padding' >
         <Card className='homepagetestimonial_cardsize'>

         <Row className='homepagetestimonial_imagestyle'>
         <Col md={2}>
         </Col>
         <Col md={6}>
         <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
         </Col>
         <Col md={4}>
         </Col>
         </Row>

         <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
         <Row>
         <Col md={4}>
         </Col>
         <Col md={4}>
         <Image variant="top" src={Nakul} alt='Nakul Acharya ' className='homepagetestimonial_imagesizing' roundedCircle />
         </Col>
         <Col md={4}>
         </Col>
         </Row>
         <p className='homepagetestimonial_contentfont'>
         <strong>
         <br/>
        "ಏಕತ್ವ ಇನೊವೇಶನ್ಸ್" ಹೆಸರಿಗೆ ತಕ್ಕಂತೆ ಏಕತೆ, ಬುದ್ದಿವಂತಿಕೆ, ಚುರುಕುತನ ಹೊಂದಿರುವ ಪ್ರಬುದ್ಧ ಯುವ ಉದ್ಯಮಿಗಳ ಸರ್ವಶ್ರೇಷ್ಠ ತಂಡ.
         </strong>
         <br/>
         <br/>
         <span className='it_ssnamecolor'> ನಕುಲ್ ಆಚಾರ್ಯ,</span>
         <span className='aboutus_fontbold' ><br/>ವಿ-ಟೆಕ್ ಇಂಜಿನಿಯರ್ಸ್,</span>
         <span><br/>ಕುಂಟವಳ್ಳಿ</span>
         </p>
         </div>
        </Card>
        </div>
        </div>
        </Col>

      </Row>

      <Row>
      <Col>
        <div className='homepagetestimonial_carouselspacing'>
        <div className='homepagetestimonial_padding' >
        <Card className='homepagetestimonial_cardsize'>
        <Row className='homepagetestimonial_imagestyle'>
        <Col md={2}>
        </Col>
        <Col md={6}>
                    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
        </Col>
        <Col md={4}>
        </Col>
        </Row>

        <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
        <Row>
        <Col md={4}>
        </Col>
        <Col md={4}>
        <Image variant="top" src={Upendra} alt='Prof H A Upendra Kumar' className='homepagetestimonial_imagesizing' roundedCircle />
        </Col>
        <Col md={4}>
        </Col>
        </Row>


        <p className='homepagetestimonial_contentfont'>
        <br/>
        <strong>
        Thanks a lot for an attractive and user-friendly website as per our needs,
        that played a major role in the success of the National Symposium
        </strong>
        </p>
        <p className='homepagetestimonial_contentfont'>
        <span className='it_ssnamecolor'>Prof H A Upendra,</span>
        <span className='aboutus_fontbold'>
        <br/>CO Chair of ISVM convention,
        </span>
        <span>
        <strong>
        <br/>Head, Dept of Veterinary Medicine, KVAFSU,<br/> Bangalore
        </strong>
        </span>
        </p>
        </div>
        </Card>
        </div>
        </div>

        </Col>
      </Row>

      <Row>
      <Col>
        <div className='homepagetestimonial_carouselspacing'>
        <div className='homepagetestimonial_padding'>
        <Card className='homepagetestimonial_cardsize'>
        <Row className='homepagetestimonial_imagestyle'>
        <Col md={2}>
        </Col>
        <Col md={6}>
                    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
        </Col>
        <Col md={4}>
        </Col>
        </Row>

        <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >

        <Row>
        <Col md={4}>
        </Col>
        <Col md={4}>
        <Image variant="top" src={Kiran} alt='CS Kiran N P' className='homepagetestimonial_imagesizing' roundedCircle />
        </Col>
        <Col md={4}>
        </Col>
        </Row>

        <p className='homepagetestimonial_contentfont'>
        <br/>
        <strong>
        Thank you for the tracking software that made my work simpler,
        easy to keep track of DSCs, Documents and find it on time. Kudos to the team.
        </strong>
        </p>
        <br/>
        <p className='homepagetestimonial_contentfont'>
        <span className='it_ssnamecolor'>CS Kiran. N.P.</span>
        <span className='aboutus_fontbold'>
        <br/>Company Secretary in Practice,
        </span>
        <span>
        <strong>
        <br/>Shivamogga
        </strong>
        </span>
        </p>
        </div>
        </Card>
        </div>
        </div>

        </Col>

      </Row>

      <Row>
      <Col>
            <div className='homepagetestimonial_carouselspacing'>
            <div className='homepagetestimonial_padding'>
            <Card className='homepagetestimonial_cardsize'>
            <Row className='homepagetestimonial_imagestyle'>
            <Col md={2}>
            </Col>
            <Col md={6}>
                        <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >

            <Row>
            <Col md={4}>
            </Col>
            <Col md={4}>
            <Image id='shadow' variant="top" src={Vidyashankar} alt='Dr. M H Vidyashankar' className='homepagetestimonial_imagesizing' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>


            <p className='homepagetestimonial_contentfont'>
            <br/>
            <strong>
            ಏಕತ್ವ ಇನ್ನೋವೇಶನ್ಸ್ ಹೆಸರೇ ಹೇಳಿದಂತೆ ಏಕತ್ವವನ್ನು ಸಾರುತ್ತಿದ್ದಾರೆ, ಸಮಾಜಮುಖಿ ಕಾರ್ಯಕ್ರಮದೊಂದಿಗೆ
            ಮಲೆನಾಡಿನ ಹುಡುಗರು ನಮ್ಮ ಜಿಲ್ಲೆಗೆ ಹೆಮ್ಮೆ ಎನಿಸಿದ್ದಾರೆ
            </strong>
            <br/>
            <br/>
            <span className='it_ssnamecolor'>
            ಡಾ. ವಿದ್ಯಾಶಂಕರ್ ಎಂ. ಹೆಚ್,
            </span>
            <span className='aboutus_fontbold'>
            <br/>ಅಧ್ಯಕ್ಷರು, ವಿಶ್ವ ಭೂಷಣ ವಿಶ್ವಸ್ತ ಮಂಡಳಿ,
            </span>
            <span>
            <strong>
            <br/>ಭದ್ರಾವತಿ
            </strong>
            </span>
            </p>
            </div>
            </Card>
            </div>
            </div>
            </Col>
      </Row>

      <Row>
      <Col>
            <div className='homepagetestimonial_carouselspacing'>
            <div className='homepagetestimonial_padding'>
            <Card className='homepagetestimonial_cardsize'>
            <Row className='homepagetestimonial_imagestyle'>
            <Col md={2}>
            </Col>
            <Col md={6}>
                        <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
            <Row>
            <Col md={4}>
            </Col>
            <Col md={4}>
            <Image id='shadow' variant="top" src={Gowrav} alt='Gowrav Bharghav' className='homepagetestimonial_imagesizing' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>


            <p className='homepagetestimonial_contentfont'>
            <br/>
            <strong>
            Your timely support enabled us in rapid prototyping our vision of automating the existing
            agricultural practices with farmer friendly innovations.
            </strong>
            <br/>
            <br/>
            <span className='it_ssnamecolor'>
            Gowrav Bhargav K R,
            </span>
            <span className='aboutus_fontbold'>
            <br/>Sri Gowri Bhargava Private Limited,
            </span>
            <span>
            <strong>
            <br/>Koppa
            </strong>
            </span>
            </p>
            </div>
            </Card>
            </div>
            </div>
            </Col>
      </Row>

      <Row>
      <Col>
            <div className='homepagetestimonial_carouselspacing'>
            <div className='homepagetestimonial_padding'>
            <Card className='homepagetestimonial_cardsize'>
            <Row className='homepagetestimonial_imagestyle'>
            <Col md={2}>
            </Col>
            <Col md={6}>
                        <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >

            <Row>
            <Col md={4}>
            </Col>
            <Col md={4}>
            <Image id='shadow' variant="top" src={Sachin} alt=' Sachin Hegdekudgi' className='homepagetestimonial_imagesizing' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <p className='homepagetestimonial_contentfont'>
            <br/>
            <strong>
            The team at Ekathva always works with a structured approach with an end result in mind.
            Time and again they have surprised me with the quality of work.
            </strong>
            <br/>
            <br/>
            <span className='it_ssnamecolor'>
            Sachin Hegdekudgi,
            </span>
            <span className='aboutus_fontbold'>
            <br/>RootsGoods (OPC) Pvt Ltd,
            </span>
            <span>
            <strong>
            <br/>Bengaluru
            </strong>
            </span>
            </p>
            </div>
            </Card>
            </div>
            </div>
            </Col>
      </Row>

      <Row>
      <Col>
            <div className='homepagetestimonial_carouselspacing'>
            <div className='homepagetestimonial_padding'>
            <Card className='homepagetestimonial_cardsize'>
            <Row className='homepagetestimonial_imagestyle'>
            <Col md={2}>
            </Col>
            <Col md={6}>
                        <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
            <Row>
            <Col md={4}>
            </Col>
            <Col md={4}>
            <Image id='shadow' variant="top" src={Niveditha} alt='Niveditha' className='homepagetestimonial_imagesizing' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <p className='homepagetestimonial_contentfont'>
            <br/>
            <strong>
            The excellent website design for our institute displays the hallmark of professionalism of
            the web developers and designers at Ekathva Innovations.
            </strong>
            <br/>
            <br/>
            <span className='it_ssnamecolor'>
            Niveditha,
            </span>
            <span className='aboutus_fontbold'>
            <br/> Assistant Professor,
            </span>
            <span>
            <strong>
            <br/>GFGC Kalasa
            </strong>
            </span>
            </p>
            </div>
            </Card>
            </div>
            </div>
            </Col>
      </Row>

      <Row>
      <Col>
            <div className='homepagetestimonial_carouselspacing'>
            <div className='homepagetestimonial_padding'>
            <Card className='homepagetestimonial_cardsize'>
            <Row className='homepagetestimonial_imagestyle'>
            <Col md={2}>
            </Col>
            <Col md={6}>
                        <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
            <Row>
            <Col md={4}>
            </Col>
            <Col md={4}>
            <Image id='shadow' variant="top" src={Aditya} alt='Aditya K' className='homepagetestimonial_imagesizing' roundedCircle />
            </Col>
            <Col md={4}>
            </Col>
            </Row>

            <p className='homepagetestimonial_contentfont'>
            <br/>
            <strong>
            The General Development Board is so compact, instead of carrying too many components.
            Best one if you want to explore any microcontroller based boards
            </strong>
            <br/>
            <br/>
            <span className='it_ssnamecolor'>
            Aditya K,
            </span>
            <span className='aboutus_fontbold'>
            <br/>Electronic Hobbyist,
            </span>
            <span>
            <strong>
            <br/>Shivamogga
            </strong>
            </span>
            </p>
            </div>
            </Card>
            </div>
            </div>
            </Col>
      </Row>
    </Carousel>

    </div>
    </div>
  )
}

export default Testi
